<script>
  const NodeContent = {
    name: 'node-content',
    props: ['node'],
    render (h) {
      const node = this.node
      const vm = this.node.tree.vm

      if (node.isEditing) {
        let nodeText = node.title

        this.$nextTick(() => {
          this.$refs.editCtrl.focus()
        })

        return h('input', {
          domProps: {
            value: node.title,
            type: 'text'
          },
          class: 'tree-input',
          on: {
            input (e) {
              nodeText = e.target.value
            },
            blur () {
              node.stopEditing(nodeText)
            },
            keyup (e) {
              if (e.keyCode === 13) {
                node.stopEditing(nodeText)
              }
            },
            mouseup (e) {
              e.stopPropagation()
            }
          },
          ref: 'editCtrl'
        })
      }

      if (vm.$scopedSlots.default) {
        return vm.$scopedSlots.default({ node: this.node })
      }
      let text = node.title.split(' ');
      let title = node.title;
      if (text.length > 2){
        title = '';
        let flag = false;
        for (let i = 0; i < text.length; i++){
          if(i != 1) {
            if (i % 2 || flag) {
                /*title += ' <br> ';*/
            }
          }
          title += text[i]+' ';
        }
      }

      return h('span', {
        domProps: {
          innerHTML: title
        }
      })
    }
  }

  export default NodeContent
</script>